import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { formatDisplayName } from '../utils/displayName';

const Navbar: React.FC = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [logoError, setLogoError] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-14 sm:h-16">
          <Link to="/" className="flex items-center gap-2 touch-manipulation">
            {!logoError ? (
              <img 
                src="/images/tri2fly-logo.png" 
                alt="Tri2Fly Logo" 
                className="h-8 sm:h-10 w-auto"
                onError={() => setLogoError(true)}
              />
            ) : (
              <span className="text-xl sm:text-2xl font-bold">
                <span className="text-primary-500">Tri</span>
                <span className="text-accent-500">2</span>
                <span className="text-primary-500">Fly</span>
              </span>
            )}
          </Link>
          <div className="flex items-center gap-2 sm:gap-4">
            {isAuthenticated ? (
              <>
                {isAdmin && (
                  <Link
                    to="/admin"
                    className="text-gray-700 hover:text-primary-600 px-2 sm:px-3 py-2 rounded-md text-xs sm:text-sm font-medium touch-manipulation min-h-[44px] flex items-center"
                  >
                    <span className="hidden sm:inline">Admin</span>
                    <span className="sm:hidden">⚙️</span>
                  </Link>
                )}
                <span className="text-gray-700 text-xs sm:text-sm hidden sm:inline">
                  Welcome, <strong>{user ? formatDisplayName(user) : ''}</strong>
                </span>
                <span className="text-gray-700 text-xs sm:hidden">
                  <strong>{user ? formatDisplayName(user).split(' ')[0] : ''}</strong>
                </span>
                <button
                  onClick={handleLogout}
                  className="bg-accent-500 text-white px-3 sm:px-4 py-2 rounded hover:bg-accent-600 text-xs sm:text-sm font-medium touch-manipulation min-h-[44px] transition-colors duration-200"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="bg-primary-600 text-white px-3 sm:px-4 py-2 rounded hover:bg-primary-700 text-xs sm:text-sm touch-manipulation min-h-[44px] flex items-center transition-colors duration-200"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

